import { format } from "date-fns";
import { Location } from "types/location";
interface AutocompleteOption {
  label: string;
  id: string | number | undefined;
  address?: string;
  zipcode?: string;
}

export function formatDate(dateString: string) {
  if (!dateString) return;
  var date = new Date(dateString.substring(0, 10)).toISOString().slice(0, -1);

  return format(new Date(date), "MMMM dd, yyyy"); // ex: April 27, 2022;
}

export function numberWithCommas(x: number | string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatNumberToCurrency(number: number) {
  return number.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}

export const formatLocations = (locations: Location[], idPropertyName = "uuid", withEmptyOption = true) => {
  let formattedLocations: AutocompleteOption[] = withEmptyOption ? [{ label: "None", id: "" }] : [];
  if (locations) {
    locations.forEach((location) => {
      formattedLocations.push({
        label: `${location.name || ""} — ${location.address || ""} ${location.address2 || ""} — ${
          location.city || ""
        }, ${location.state || ""}`,
        id: location[idPropertyName as keyof Location] as string,
      });
    });
  }
  return formattedLocations;
};
